import { buildDefaultDataProperty } from '@bingads-webui-campaign-react/ui-generator';

export const buildSchema = options => ({
  separatorStyles: {
    marginBottom: 20,
  },
  ads: {
    type: 'panel',
    header: {
      title: 'Ads',
      actionButton: {
        label: _TL_('Edit'),
        iconName: 'Edit',
        ariaLabel: _TL_('Edit'),
        onClick: options.onAdsHeaderActionClick,
      },
    },
    components: {
      adCreation: {
        type: 'ad-creation',
        dynamicProps: props => props.adCreation,
      },
    },
    dynamicProps: props => props.adsPanel,
  },
  targeting: {
    type: 'panel',
    header: {
      title: _TL_('Targeting'),
      actionButton: {
        label: _TL_('Edit'),
        iconName: 'Edit',
        ariaLabel: _TL_('Edit'),
        onClick: options.onTargetingHeaderActionClick,
      },
    },
    components: {
      separatorStyles: {
        marginBottom: 8,
      },
      adGroupName: buildDefaultDataProperty({
        label: _TL_('Ad group name'),
        dynamicProps: props => props.adGroupName,
      }),
      hd1: {
        type: 'horizontal-divider',
      },
      locationTargeting: {
        type: 'location-targeting',
        dynamicProps: props => props.locationTargeting,
      },
      genderTargeting: {
        type: 'gender-targeting',
        dynamicProps: props => props.genderTargeting,
      },
      ageRangeTargeting: {
        type: 'age-range-targeting',
        dynamicProps: props => props.ageRangeTargeting,
      },
      genreTargeting: {
        type: 'genre-targeting',
        dynamicProps: props => props.genreTargeting,
      },
      predictiveTargeting: {
        type: 'predictive-targeting',
        dynamicProps: props => props.predictiveTargeting,
      },
      advancedTargetingSeparator: {
        type: 'horizontal-divider',
        dynamicProps: props => props.advancedTargetingSeparator,
      },
      interest: {
        type: 'interest',
        dynamicProps: props => props.interest,
      },
      audience: {
        type: 'audience',
        dynamicProps: props => props.audience,
      },
      company: {
        type: 'company',
        dynamicProps: props => props.company,
      },
      jobFunction: {
        type: 'job-function',
        dynamicProps: props => props.jobFunction,
      },
      industry: {
        type: 'industry',
        dynamicProps: props => props.industry,
      },
      adScheduleAdGroup: {
        type: 'ad-schedule',
        dynamicProps: props => props.adScheduleAdGroup,
      },
    },
  },
  campaignSettings: {
    type: 'panel',
    header: {
      title: _TL_('Campaign settings'),
      actionButton: {
        label: _TL_('Edit'),
        iconName: 'Edit',
        ariaLabel: _TL_('Edit'),
        onClick: options.onCampaignSettingsHeaderActionClick,
      },
    },
    components: {
      separatorStyles: {
        marginBottom: 8,
      },
      campaignName: buildDefaultDataProperty({
        label: _TL_('Campaign name'),
        dynamicProps: props => props.campaignName,
      }),
      conversionGoals: {
        type: 'conversion-goals',
        dynamicProps: props => props.conversionGoals,
      },
      budget: {
        type: 'budget',
        dynamicProps: props => props.budget,
      },
      bidStrategy: {
        type: 'bid-strategy',
        dynamicProps: props => props.bidStrategy,
      },
      bidValue: {
        type: 'bid-value',
        dynamicProps: props => props.bidValue,
      },
      hd1: {
        type: 'horizontal-divider',
      },
      startEndDatesCampaign: {
        type: 'start-end-dates',
        dynamicProps: props => props.startEndDatesCampaign,
      },
    },
  },
});
